import { Api } from 'utils';

class RouteService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/routes',params),
		create: async (params?: any) => Api.createResponse('admin/routes/create',params),
		delete: async (params?: any) => Api.createResponse('admin/routes/delete',params)
	}

}

export default RouteService;